import { Component, DoCheck, HostListener, Inject, OnChanges, OnInit, SimpleChanges, ViewChild, OnDestroy, ChangeDetectorRef } from '@angular/core';
import {
  ActivatedRoute, NavigationCancel, NavigationEnd, NavigationError, NavigationStart,
  Router
} from '@angular/router';
import { DataManagerService } from './data/services/DataManager/data-manager.service';
import { BaseComponent } from './abstract/base.component';
import { AppConstants } from './shared/constants/app-constants';
import { PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ProfileDialogComponent } from './dialogs/profile-dialog/profile-dialog.component';
import { UpdateContactDialogComponent } from './dialogs/update-contact-dialog/update-contact-dialog.component';
import { AccountModel } from './data/model/AccountModel/account.model';
import { IdleService } from './services/idle.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { environment } from '../environments/environment';
import {ZendeskWidgetService} from './services/zendesk-widget.service';
declare let gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent extends BaseComponent implements OnInit, DoCheck, OnChanges, OnDestroy {
  title = 'app';
  sideNavFlag: boolean;
  currentLocation: string;
  currentResolution: number;
  name: string;
  currentUsers: AccountModel[];
  activeUser: AccountModel;
  _getaccount: string;
  serviceName: string;
  currentAccountId: string;
  countdown: number = 0;
  showCountdown: boolean = false;
  private countdownSub: Subscription;
  private resetSub: Subscription;
  private readonly brandingCacheKey = 'branding_manifest_cache_v1';
  @ViewChild('myModalClose') modalClose;
  get userName(): any {
    const currentUser1 = JSON.parse(localStorage.getItem(AppConstants.STORAGE_KEY_USER_NAME));
    return currentUser1;
  }

  get userEmail(): any {
    const currentUser1 = JSON.parse(localStorage.getItem(AppConstants.STORAGE_KEY_USER_EMAIL));
    return currentUser1;
  }

  constructor(router: Router, dialog: MatDialog, dataManager: DataManagerService, route: ActivatedRoute,
    @Inject(PLATFORM_ID) private platformId: any,
    @Inject('LOCALSTORAGE') private localStorage: any,
    private _route: ActivatedRoute, private localeService: BsLocaleService,
    private idleService: IdleService,
    private cdr: ChangeDetectorRef,
    private zendesk: ZendeskWidgetService) {
    super();
    this.dataManager = dataManager;
    this.router = router;
    this.route = route;
    this.currentLocation = location.pathname;
    this.currentResolution = window.screen.width;
    this.name = null;
    this.serviceName = '/switch';
    this.alertDialog = dialog;
    if (location.pathname !== '/pay/' && location.pathname !== '/pay-ach/') {
      this.toggleSidNav();
    }
    this.currentUsers = [];
    this.activeUser = new AccountModel();
    this._getaccount = AppConstants.BASE_URL + AppConstants.SERVICE_NAME_ACCOUNT;
    this.currentAccountId = JSON.parse(localStorage.getItem(AppConstants.STORAGE_KEY_CURRENT_ACCOUNT_ID));
    /*this.router.navigate(['/reports/transaction-reports']);*/
    if (environment.googleAnalyticsId && typeof gtag !== 'undefined') {
      this.router.events.pipe(
        filter(event => event instanceof NavigationEnd)
      ).subscribe((event: NavigationEnd) => {
        gtag('config', environment.googleAnalyticsId, {
          page_path: event.urlAfterRedirects
        });
        console.log('GA pageview triggered:', event.urlAfterRedirects);
      });
    }
  }

  ngOnInit() {
    this.localeService.use('en-gb');

    this.loadBranding();
    console.log('called appcomponent');
    // alert(location.pathname);
    if (isPlatformBrowser(this.platformId) &&
      !location.pathname.includes('/pay/') &&
      location.pathname !== '/pay-ach/' &&
      location.pathname !== '/admin') {
      console.log(this.localStorage.getItem(AppConstants.STORAGE_KEY_ACCESS_TOKEN));
      this.dataManager.accessToken = this.localStorage.getItem(AppConstants.STORAGE_KEY_ACCESS_TOKEN);
      this.dataManager.user = JSON.parse(this.localStorage.getItem(AppConstants.STORAGE_KEY_USER));
      // this.dataManager.setPermissions(this.localStorage.setItem(AppConstants.STORAGE_KEY_USER_ROLES));
      this.dataManager.accessTokenExists() ? this.dataManager.createHeaderWithUersAccessToken() : '';
      this._route.queryParams.subscribe((params) => {
      });
      console.log('menu on refrsh',
        this.localStorage.getItem(AppConstants.STORAGE_KEY_USER_MENU)
        , JSON.parse(this.localStorage.getItem(AppConstants.STORAGE_KEY_USER_MENU)));
      this.dataManager.permissionsArray = JSON.parse(this.localStorage.getItem(AppConstants.STORAGE_KEY_USER_PERMISSIONS));
      console.log('permissions  array', this.dataManager.permissionsArray);
      if ((this.localStorage.getItem(AppConstants.STORAGE_KEY_USER_MENU))) {
        console.log('send menu')
        this.dataManager.setMenuArray(JSON.parse(this.localStorage.getItem(AppConstants.STORAGE_KEY_USER_MENU)));
      }
    }
    // Manage timeout inactivity initialization
    // console.log('### AppComponent ngOnInit');
    this.countdownSub = this.idleService.getCountdownObservable().subscribe((timeLeft) => {
      this.countdown = timeLeft;
      // console.log('### AppComponent countdown', this.countdown, timeLeft);
      this.showCountdown = true;
      this.cdr.detectChanges();
    });
    // Subscribe to reset events to hide the countdown
    this.resetSub = this.idleService.getResetIdleObservable().subscribe(() => {
      this.showCountdown = false;
      this.cdr.detectChanges();
    });
    this.idleService.getLogoutObservable().subscribe(() => {
      this.showCountdown = false;
      this.cdr.detectChanges();
      // console.log('### getLogoutObservable in app component');
      alert('You have been logged out due to inactivity.');
    });
    this.zendesk.load();
    this.router.events.subscribe(
      (response) => {
        // alert(location.pathname);

        if (response instanceof NavigationStart && location.pathname !== '/admin') {
          this.dataManager.appLoaderFlag(true);
        } else if (response instanceof NavigationEnd) {
          this.dataManager.appLoaderFlag(false);
        } else if (response instanceof NavigationError) {
          this.dataManager.appLoaderFlag(false);
        } else if (response instanceof NavigationCancel) {
          this.dataManager.appLoaderFlag(false);
        }
      },
      (error) => {
      }
    );

  }
  // Manage timeout inactivity initialization
  cancelLogout() {
    // console.log('### cancelLogout');
    this.idleService.cancelLogout();
    this.showCountdown = false;
    this.cdr.detectChanges();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (location.pathname !== '/pay/' && location.pathname !== '/pay-ach/') {
      this.toggleSidNav();
    }
  }
  setUserAccounts() {
    this.currentUsers = JSON.parse(localStorage.getItem(AppConstants.STORAGE_KEY_ACCOUNT_ID));
    if (!this.isNullOrUndefined(this.currentUsers) && this.currentUsers.length > 0) {
      this.setCurrentAccount();
    }
  }
  refreshScreen() {
    this.dataManager.accessTokenExists() ? console.log('accessTokenPresent') : this.routeNavigate('/signin');

  }

  ngDoCheck() {
    if (((location.pathname !== this.currentLocation) || (this.currentResolution !== window.screen.width))
      && (location.pathname !== '/pay/' && location.pathname !== '/pay-ach/')) {
      this.currentLocation = location.pathname;
      this.currentResolution = window.screen.width;
      if (location.pathname !== '/pay/' && location.pathname !== '/pay-ach/') {
        this.toggleSidNav();
      }
    }

    // if (location.pathname === '/customer') {
    //   this.routeNavigate('/customer/customer-list');
    // }
  }

  toggleSidNav() {
    this.sideNavFlag = this.matchUrl('/signin') || this.matchUrl('/register') ||
      this.matchUrl('/loading..') || location.pathname === '/pay/' || location.pathname === '/pay-ach/'
      ? false : (window.screen.width > 767 ? true : false);
  }

  showSideNav() {
    this.sideNavFlag = window.screen.width > 767 ? true : !this.sideNavFlag;
  }
  setCurrentAccount() {
    this.activeUser = this.currentUsers.find(x => x.id === this.currentAccountId);
  }
  switchAccount(id, account_name) {
    console.log('switchaccount', id);
    localStorage.removeItem(AppConstants.STORAGE_KEY_CURRENT_ACCOUNT_NAME);
    if (isPlatformBrowser(this.platformId)) {
      this.localStorage.setItem(AppConstants.STORAGE_KEY_CURRENT_ACCOUNT_NAME, JSON.stringify(account_name));
    }


    this._getaccount = AppConstants.BASE_URL + this.serviceName + '/' + id;

    this.router.navigate(['loading..']);
  }

  private async loadBranding() {
  this.dataManager.brandingReady = false;

  const host = location.hostname;
  // const host = 'whitedashboard.payarc.net';
  // const host = 'dashboard.payarc.net';
  const ttlMs = this.getBrandingTtlMs();
  const cached = this.getCachedBranding(host, ttlMs);

  let manifest;

  if (cached) {
    manifest = cached;
  } else {
    manifest = await this.fetchBrandingManifest(host);
    if (manifest) {
      this.storeBrandingCache(host, manifest);
    }
  }

  if (manifest) {
    this.applyBranding(manifest);
  } else {
    this.applyLegacySubdomainBranding(host);
    this.applyDefaultBranding(host); 
  }

  this.dataManager.brandingReady = true;
}

  private getBrandingTtlMs(): number {
    const configured = (environment as any).branding_manifest_ttl_ms;
    return typeof configured === 'number' ? configured : 5 * 60 * 1000;
  }

  private getCachedBranding(host: string, ttlMs: number) {
    try {
      const raw = localStorage.getItem(this.brandingCacheKey);
      if (!raw) {
        return null;
      }
      const parsed = JSON.parse(raw);
      if (!parsed || parsed.host !== host || !parsed.manifest || !parsed.timestamp) {
        return null;
      }
      if (Date.now() - parsed.timestamp > ttlMs) {
        return null;
      }
      return parsed.manifest as { site_title?: string; logo_url?: string; favicon_url?: string; agent_company_dba?: string };
    } catch (error) {
      return null;
    }
  }

  private storeBrandingCache(host: string, manifest: { site_title?: string; logo_url?: string; favicon_url?: string; agent_company_dba?: string }) {
    try {
      const payload = {
        host,
        timestamp: Date.now(),
        manifest
      };
      localStorage.setItem(this.brandingCacheKey, JSON.stringify(payload));
    } catch (error) {
      // Ignore storage errors (e.g. quota or disabled storage).
    }
  }

  private async fetchBrandingManifest(host: string) {
    try {
      const { manifestUrl, assetBaseUrl } = this.getBrandingUrls(host);
      const response = await fetch(manifestUrl);
      if (!response.ok) {
        return null;
      }
      const manifest = await response.json();
      return this.normalizeManifestAssets(manifest, assetBaseUrl);
    } catch (error) {
      return null;
    }
  }

  private getBrandingUrls(host: string) {
    const slug = this.slugifyHost(host);
    const assetBaseUrl = AppConstants.LOGO_BASE_URL + slug + '/';
    return {
      assetBaseUrl,
      manifestUrl: assetBaseUrl + 'manifest.json'
    };
  }

  private slugifyHost(host: string) {
    let slug = host.toLowerCase();
    slug = slug.replace(/^https?:\/\//, '');
    slug = slug.replace(/[^a-z0-9]+/g, '_');
    slug = slug.replace(/^_+|_+$/g, '');
    return slug;
  }

  private applyBranding(manifest: { site_title?: string; logo_url?: string; favicon_url?: string; dashboard_url?: string; partnerhub_url?: string; agent_company_dba?: string }) {

    if (manifest.site_title) {
      document.title = manifest.site_title;
      this.dataManager.orgName = manifest.site_title;
    }
    if (manifest.agent_company_dba) {
      // document.title = manifest.agent_company_dba;
      this.dataManager.Dba = manifest.agent_company_dba;
    }
    if (manifest.logo_url) {
      this.dataManager.logoUrl = manifest.logo_url;
      this.dataManager.loginlogo = manifest.logo_url;
    }
    if (manifest.favicon_url) {
      this.updateFavicon(manifest.favicon_url);
    }
    // if (manifest.partnerhub_url) {
    //   this.dataManager.partnerhubUrl = manifest.partnerhub_url;
    // }
    this.dataManager.partnerhubUrl = manifest.partnerhub_url || null;
  }

  private normalizeManifestAssets(manifest: { site_title?: string; logo_url?: string; favicon_url?: string; dashboard_url: string; partnerhub_url: string; agent_company_dba: string }, assetBaseUrl: string) {
    if (!manifest || typeof manifest !== 'object') {
      return null;
    }
    return {
      site_title: manifest.site_title,
      logo_url: this.resolveManifestUrl(manifest.logo_url, assetBaseUrl),
      favicon_url: this.resolveManifestUrl(manifest.favicon_url, assetBaseUrl),
      dashboard_url: manifest.dashboard_url,
      partnerhub_url: manifest.partnerhub_url,
      agent_company_dba: manifest.agent_company_dba
    };
  }

  private resolveManifestUrl(value: string, assetBaseUrl: string) {
    if (!value) {
      return undefined;
    }
    const trimmed = value.trim();
    if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
      return trimmed;
    }
    if (trimmed.startsWith('//')) {
      return `${window.location.protocol}${trimmed}`;
    }
    if (trimmed.startsWith('/')) {
      // Treat leading-slash paths as relative to the manifest folder (assetBaseUrl),
      // not as absolute paths on the current app origin.
      const relativePath = trimmed.replace(/^\/+/, '');
      return assetBaseUrl + relativePath;
    }
    const relativePath = trimmed.replace(/^\/+/, '');
    return assetBaseUrl + relativePath;
  }

  private updateFavicon(url: string) {
    const head = document.head || document.getElementsByTagName('head')[0];
    let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement | null;
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      head.appendChild(link);
    }
    if (link.hasAttribute('type')) {
      link.removeAttribute('type');
    }
    link.href = url;
  }

  private applyLegacySubdomainBranding(host: string) {
    const subdomain = host.split('.')[0];
    if (!subdomain) {
      return;
    }
    const blocked = ['dashboard', 'dashboard2', 'testdashboard', '192', 'uatdashboard', 'localhost'];
    if (blocked.includes(subdomain)) {
      return;
    }

    const name = host.endsWith('payarc.net') ? subdomain : host.replace(/\./g, '_');

    this.dataManager.logoUrl = AppConstants.LOGO_BASE_URL + name + '_dashboard.png';
    this.dataManager.loginlogo = AppConstants.LOGO_BASE_URL + name + '_login.png';
  }

private applyDefaultBranding(host: string) {
  const defaultLogo = 'assets/images/Merchant_Dashboard_Default_Logo.svg';
  const payarcLogo = 'assets/images/payarc.svg';
  const defaultFavicon = 'assets/images/default-favicon.ico';

  this.dataManager.showPrivacyLinks = false;
  this.dataManager.partnerhubUrl = environment.partnerHubUrl;

  if (/^(?:test|uat)?dashboard\.payarc\.(net|io)$/i.test(host)) {
    this.dataManager.logoUrl = payarcLogo;
    this.dataManager.loginlogo = payarcLogo;
    this.dataManager.showPrivacyLinks = true;
    if (!this.getCurrentFavicon()) {
      this.updateFavicon(payarcLogo);
    }
    return;
  }

  this.dataManager.logoUrl = defaultLogo;
  this.dataManager.loginlogo = defaultLogo;
  if (!this.getCurrentFavicon()) {
    this.updateFavicon(defaultFavicon);
  }
}

private getCurrentFavicon(): string | null {
  const link = document.querySelector("link[rel~='icon']") as HTMLLinkElement | null;
  return link ? link.href : null;
}

}

